module.exports = __webpack_public_path__ + "static/media/ql-icon-speeddating.325ce7ef.svg";